// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VirtualKeyboard_wrapper__3NlvP","slide-in":"VirtualKeyboard_slide-in__1Z3r6","smaki":"VirtualKeyboard_smaki__2LL-X","root":"VirtualKeyboard_root___N6kQ"};